"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _ReferenceRecord = _interopRequireDefault(require("reference-resolvers/schema/ReferenceRecord"));

var _default = function _default(_ref) {
  var currencyExchangeRates = _ref.currencyExchangeRates,
      hasMulticurrencyActive = _ref.hasMulticurrencyActive,
      homeCurrency = _ref.homeCurrency;
  var defaultRecord = (0, _ReferenceRecord.default)({
    id: 'default',
    label: homeCurrency.currencyCode,
    referencedObject: (0, _immutable.Map)((0, _extends2.default)({}, homeCurrency, {
      hasMulticurrencyActive: hasMulticurrencyActive
    }))
  });
  var exchangeRecords = currencyExchangeRates.reduce(function (acc, exchangeRate) {
    return acc.set(exchangeRate.fromCurrencyCode, (0, _ReferenceRecord.default)({
      id: exchangeRate.fromCurrencyCode,
      label: exchangeRate.fromCurrencyCode,
      description: "" + exchangeRate.conversionMultiplier,
      referencedObject: (0, _immutable.Map)(exchangeRate)
    }));
  }, (0, _immutable.Map)());
  return exchangeRecords.set('default', defaultRecord);
};

exports.default = _default;
module.exports = exports.default;